import Vue from 'vue'
import Vuex from 'vuex'
import { get } from '@/api/request.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 公共数据
    SectorData: []
  },
  mutations: {
    CommonInterfaceDataMutations (state, data) {
      state.SectorData = data
    }
  },
  actions: {
    CommonInterfaceDataActions (context, payload) {
      get(payload).then((res) => {
        context.commit('CommonInterfaceDataMutations', res.data)
      })
    }
  },
  modules: {
  }
})
